import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Dropdown, DropdownMenu, DropdownOption, DropdownTrigger } from "../../components/ui/Dropdown";
import Loading from "../../components/Loading";

const icons = [
  "/user-list.svg",
  "/package-openWhite.svg",
  "/speedometerwhite.svg",
  "/package-open.svg",
  "/speedometer.svg",
  "/user-question.svg",
];

const Main = ({ selectedListName, setSelectedListName, isLoading }) => {
  const { data } = useSelector((state) => state.dashboard);
  const { listNames } = useSelector(
    (state) => state.myList
  );
  const filteredList = useMemo(() => {
    let list = ["All", ...listNames]
    return list || ["All"];
  }, [listNames]);
  return (
    <div className="flex justify-center w-full font-fira mt-[120px] md:mt-[160px] items-center mb-10 xs:mb-12 sm:mb-14 lg:mb-20">
      <div className="flex flex-col w-[90%] max-w-[1400px] items-center">
        <div className="text-center space-y-1 sm:space-y-2 my-5">
          <p className="sm:text-lg mb-12 text-cherry">
            Spring Branch ISD Election Day rosters were received and all user accounts now reflect everyone who voted in the May 5, 2025 SBISD Election.
          </p>
          {/* <h2 className="text-[28px] sm:text-[32px] text-[#323232] font-medium leading-[1.25]">
            Your Voting Progress Overview
          </h2> */}

          <p className="sm:text-lg">
            Track the percentage participation of 'My Voter' list
          </p>

        </div>

        <div className="flex flex-col gap-4 sm:gap-6 w-full rounded-xl max-w-[500px]">

          <div className="my-5 w-fit">
            {filteredList.length &&
              <Dropdown triggers={[isLoading]} className="order-3">
                <DropdownTrigger
                  id="toggle-columns"
                  className="flex items-center font-semibold gap-1 md:gap-3 border !h-11 px-2 md:px-3 hover:bg-[#F9F9FA] transition-colors rounded-md text-sm lg:text-[15px] relative"
                >
                  {selectedListName ? selectedListName : 'Voter List'}
                  <img
                    src={"/chevron-down.svg"}
                    className="size-6"
                    width={24}
                    height={24}
                  />
                </DropdownTrigger>

                <DropdownMenu className="">
                  {filteredList
                    .map((col, index) => (
                      <DropdownOption
                        key={`${col}-${index}`}
                        className="hover:bg-[#F9F9FA] transition-colors cursor-pointer h-9 flex items-center px-2 font-medium text-sm rounded-[7px] gap-2"
                        onClick={() => {
                          setSelectedListName(col);
                        }}
                      >
                        {col}
                      </DropdownOption>
                    ))}
                </DropdownMenu>
              </Dropdown>
            }
          </div>
          {isLoading ? (
            <div className="flex justify-center">
              <Loading />
            </div>
          ) : (
            <>
              {data ? (
                Object.keys(data).map((key, i) => {
                  let content = null;

                  if (key === 'Total Voters' || key === 'Missing Voter IDs') {
                    content = (
                      <div className="flex justify-between w-full items-center" key={i}>
                        <div className="flex items-center gap-2.5">
                          <img src={icons[i]} alt="user list" />
                          <span className="text-lg sm:text-xl text-cherry">{key}</span>
                        </div>
                        <span className="text-22px sm:text-2xl text-cherry font-bold">
                          {data[key]}
                        </span>
                      </div>
                    );
                  } else if (key === 'Total Harris County Votes') {
                    content = (
                      <div className="border rounded-md p-4 w-full bg-[#FFE5E5]" key={i}>
                        <h2 className="text-lg sm:text-xl mb-4">Harris County Votes</h2>
                        <div className="flex flex-col gap-2 xxs:flex-row">
                          <div className="flex w-full xxs:w-[50%] items-center gap-2">
                            <div className="bg-cherry rounded-full p-4">
                              <img src={icons[1]} alt="user list" />
                            </div>
                            <div className="ml-2">
                              <p className="text-22px sm:text-2xl font-bold">
                                {data['Total Harris County Votes']}
                              </p>
                              <p className="text-lg">Total Votes</p>
                            </div>
                          </div>
                          <div className="flex w-full xxs:w-[50%] items-center gap-2">
                            <div className="bg-cherry rounded-full p-4">
                              <img src={icons[2]} alt="user list" />
                            </div>
                            <div className="ml-2">
                              <p className="text-22px sm:text-2xl font-bold">
                                {data['Percentage Harris County Voted']}
                              </p>
                              <p className="text-lg">Percentage Votes</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  } 
                  // else if (key === 'Total SBISD Votes') {
                  //   content = (
                  //     <div className="border rounded-md p-4 w-full" key={i}>
                  //       <h2 className="text-lg sm:text-xl mb-4">SBISD Votes</h2>
                  //       <div className="flex flex-col gap-2 xxs:flex-row">
                  //         <div className="flex w-full xxs:w-[50%] items-center gap-2">
                  //           <div className="bg-[#FFE5E5] rounded-full p-4">
                  //             <img src={icons[3]} alt="user list" />
                  //           </div>
                  //           <div className="ml-2">
                  //             <p className="text-22px sm:text-2xl font-bold">
                  //               {data['Total SBISD Votes']}
                  //             </p>
                  //             <p className="text-lg">Total Votes</p>
                  //           </div>
                  //         </div>
                  //         <div className="flex w-full xxs:w-[50%] items-center gap-2">
                  //           <div className="bg-[#FFE5E5] rounded-full p-4">
                  //             <img src={icons[4]} alt="user list" />
                  //           </div>
                  //           <div className="ml-2">
                  //             <p className="text-22px sm:text-2xl font-bold">
                  //               {data['Percentage SBISD Voted']}
                  //             </p>
                  //             <p className="text-lg">Percentage Votes</p>
                  //           </div>
                  //         </div>
                  //       </div>
                  //     </div>
                  //   );
                  // }

                  // Only return something if a condition was met
                  return content;
                })
              ) : (
                <>No Data Found</>
              )}
            </>
          )}


        </div>


        {/* <div className="flex gap-y-8 gap-x-8 xl:gap-x-10 justify-center flex-wrap">
          {Object.keys(data).map((key, index) => {
            const isPercentageStat = data[key].includes("%");

            return !isPercentageStat ? (
              <div
                key={index}
                className="w-[320px] flex flex-col items-center justify-center text-[27px] xl:text-3xl p-5 text-center aspect-square border-[20px] lg:border-[24px] border-cherry rounded-full gap-2 lg:gap-3"
              >
                <span className="leading-[1]">{key}</span>
                <span className="leading-[1] font-semibold">{data[key]}</span>
              </div>
            ) : (
              <div
                key={index}
                className="w-[320px] flex flex-col items-center justify-center text-[27px] xl:text-3xl p-5 text-center aspect-square border-[20px] lg:border-[24px] border-transparent rounded-full gap-2 lg:gap-3 relative"
              >
                <div
                  style={{
                    background: !data
                      ? "conic-gradient(#C82446 0% 100%)"
                      : `conic-gradient(#eaeaea 0% ${
                          100 - data[key].slice(0, -1)
                        }%, #C82446 ${100 - data[key].slice(0, -1)}% 100%)`,
                  }}
                  className="absolute -inset-[24px] rounded-full -z-10 transition-all"
                ></div>
                <div className="absolute inset-0 bg-white rounded-full -z-10"></div>

                <span className="leading-[1]">{key}</span>
                <span className="leading-[1] font-semibold">{data[key]}</span>
              </div>
            );
          })}
        </div> */}
      </div>
    </div>
  );
};

export default Main;
